<template>
    <div id="app">
        <router-view v-if="!update" :key="$route.path" />
        <div v-if="update" class="col-12 col-md-8 offset-md-2 float-left mt-5 mb-5">
            <b-jumbotron class="text-center">
                <h1>
                    <font-awesome-icon icon="cogs" />
                </h1>
                <h3 class="pt-4">در حال به روزرسانی هستیم</h3>
                <h4>به زودی برمی گردیم</h4>
            </b-jumbotron>
        </div>
    </div>
</template>
<script>
    export default {
        name: "app",

        data: function ()
        {
            return {
                update: false
            };
        },
    };
</script>
<style>
    @font-face {
        font-family: "IRANSansWeb";
        src: url("./assets/font/IranSans/IRANSansWeb.ttf") format("truetype");
    }

    html,
    body,
    #app {
        font-family: IRANSansWeb !important;
        width: 100%;
        height: 100%;
        float: left;
        font-size: 15px;
        padding: 0;
        margin: 0;
    }

    @media (min-width: 1350px) {
        .container {
            max-width: 1300px !important;
        }
    }

    body {
        overflow-x: hidden;
    }

    body {
        font-size: 14px;
    }

    .pink {
        color: #f5c842;
    }

    .bg-pink {
        background: #f5c842;
    }

    .bg-silver {
        background: #f8f8f8;
    }

    .money {
        direction: ltr;
    }

    .pointer {
        cursor: pointer;
    }


    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="number"] {
        -moz-appearance: textfield;
    }

    .pl-right::-webkit-input-placeholder {
        text-align: right;
    }

    .pl-right:-moz-placeholder {
        text-align: right;
    }

    body[dir="rtl"] > #app {
        direction: rtl;
        text-align: right;
    }

    body[dir="rtl"] .float-dynamic {
        float: right;
    }

    body[dir="ltr"] .float-dynamic {
        float: left;
    }

    body[dir="rtl"] .md-field label {
        right: 0 !important;
    }

    .form-control {
        margin-bottom: 0px;
    }

    .col-form-label {
        padding-bottom: 0 !important;
    }

    .swiper-container {
        padding-right: 7px;
        padding-left: 7px;
    }

    .swiper-button-next {
        left: 0px !important;
        background: url('./assets/image/left.png') center center no-repeat;
    }

    .swiper-button-prev {
        right: 0px !important;
        background: url('./assets/image/right.png') center center no-repeat;
    }

    .swiper-button-next,
    .swiper-button-prev {
        content: "";
        width: 60px !important;
        height: 40px !important;
        top: 42% !important;
        background-size: 30px;
    }

        .swiper-button-next:after,
        .swiper-button-prev:after {
            display: none;
        }

	.shop-comment-badge {
		position: relative !important;
		background: #fff !important;
		color: #000 !important;
		border-radius: 100% !important;
		border: #ddd solid 1px !important;
		top: -10px !important;
		left: 23px !important;
		font-size: 8px !important;
	}

	.star-rating svg {
		stroke-width: 2;
		stroke: #000;
	}

    @media (max-width: 1024px) {
        .swiper-button-next,
        .swiper-button-prev {
            width: 60px !important;
            height: 20px !important;
            top: 50% !important;
        }
    }
</style>
